import React, { FC, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { ISelectorData } from '../application/NewApplication';
import { SelectPicker } from 'rsuite';

interface Props {
  title: string;
  fieldName: string;
  list: ISelectorData[];
  formik: any;
  onSelect: (fieldName: string, value: string) => Promise<void>;
  searchable?: boolean;
  disabled?: boolean;
}

export const TableSelector: FC<Props> = (props) => {
  const {
    formik,
    title,
    fieldName,
    onSelect,
    list,
    searchable = false,
    disabled = false
  } = props;

  const selectValue = formik.values[fieldName];

  const [edit, setEdit] = useState<boolean>(false);

  const handleChange = async (value: string): Promise<void> => {
    formik.setFieldValue(fieldName, value);
    await onSelect(fieldName, value);
    setEdit(false);
  };

  const selector = (
    <div>
      <div className="d-flex align-items-center">
        <SelectPicker
          className="provider-selector"
          data={list || []}
          placeholder={title}
          name={fieldName}
          value={selectValue}
          placement='bottomStart'
          onChange={handleChange}
          searchable={searchable}
          disabled={disabled}
          data-cy="active-selector"
          // onClean={(): void => formik.setFieldValue(fieldName, '')}
          // cleanable={cleanable}
          // renderMenu={renderMenu}
          // renderMenuItem={renderMenuItem}
        />

      </div>
    </div>
  );

  return (
    <>
      {
        edit
          ? selector
          : (
            <div
              className="fs-7 provider-cell cursor-pointer fc-text-overflow"
              onClick={(): void => setEdit(true)}
              data-cy="inactive-selector"
            >
              <FontAwesomeIcon icon={faPen} className="me-2 w-10px text-danger" />
              {selectValue ? selectValue : '-'}
            </div>
          )
      }
    </>
  );
};